const isPlainObject = (val) => val !== null && typeof val === "object" && !Array.isArray(val);

const addressPayload = ({ name, value, addressId }) => ({
  address_attributes: {
    ...(isPlainObject(value) ? value : { [name]: value }),
    ...(addressId ? { id: addressId } : {}),
  },
});

const detailPayload = ({ inOption, name, value }) => ({
  [inOption]: [{ name, value }],
});

const linkPayload = ({ value }) => ({
  listing_links_attributes: value,
});

const rawPayload = ({ name, value }) => ({ [name]: value });

const payloadMapper = {
  address_attributes: addressPayload,
  listing_links_attributes: linkPayload,
  null: rawPayload,
};

const choosePayload = (inOption) => payloadMapper[inOption] || detailPayload;

const buildPayload = (inOption, name, value, addressId = null) => {
  const builder = choosePayload(inOption);
  return builder({ name, value, addressId, inOption });
};

export default buildPayload;
